import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Typography,
} from 'darrius';
import { type TBonusProps } from '../@interfaces';

import styles from './Bonus.module.scss';

export const Bonus = ({ cards, title, tag }: TBonusProps) => {
  return (
    <Container
      className={`${styles['signup-mgm__bonus']} center-sm space-bottom`}
    >
      <Typography.Title size="3xl" className="space-bottom">
        {title}
      </Typography.Title>
      <Row className="center-sm space-bottom">
        {cards.map((item) => (
          <Col className="col-sm-10 col-md-4" key={item.title}>
            <Card className={styles['signup-mgm__bonus__card']}>
              <CardHeader>
                <img src={item.img} alt={item.alt} width="80px" />
              </CardHeader>
              <CardBody>
                <Typography.Subtitle size="m">{item.title}</Typography.Subtitle>
                <Typography.Text className={styles.text}>
                  {item.text}
                </Typography.Text>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="center-sm space-bottom">
        <Col
          className={`${styles['signup-mgm__bonus__tag']} col-md-8 col-sm-10`}
        >
          <img src={tag.img} alt={tag.alt} />
          <div>
            <Typography.Text>
              <b>{tag.title}</b>
            </Typography.Text>
            <Typography.Text className={styles.text}>
              {tag.text}
            </Typography.Text>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
